import { render, staticRenderFns } from "./ReportBugComponent.vue?vue&type=template&id=499054e7&"
import script from "./ReportBugComponent.vue?vue&type=script&lang=js&"
export * from "./ReportBugComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports